<div class="card-info">
    <mat-icon class="credit-card-provider-logo" style="margin-right: 0.5rem" [svgIcon]="creditCardIcon()"></mat-icon>
    <p class="card-text body-1">ending with {{ lastFourDigits() }}</p>
</div>
